<section
  class="bg relative z-50 flex min-h-[calc(100vh-220px)] justify-center bg-contain bg-top bg-no-repeat px-4 py-12 lg:px-8"
>
  <div
    class="max-h-[450px] min-h-96 w-full max-w-lg space-y-8 rounded-2xl bg-white p-10 shadow-xl"
  >
    <h2 class="text-center text-3xl text-blue-950">Onboard User to Okta</h2>

    <form
      [formGroup]="onboardingForm"
      (ngSubmit)="onSubmit()"
      class="onboarding-form mt-8 space-y-6"
    >
      <div class="flex flex-col gap-4">
        <!-- <div class="grid grid-cols-1 gap-2 md:grid-cols-2"> -->
        <mat-form-field class="w-full">
          <mat-label>Username</mat-label>
          <input matInput formControlName="username" type="email" required />
        </mat-form-field>

        <mat-form-field class="w-full">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" type="email" required />
        </mat-form-field>
        <!-- </div> -->
      </div>

      <div>
        @if (contactErrorMessage()) {
          <div
            class="mb-2 rounded bg-red-100 p-2 text-center text-sm font-semibold text-red-600"
          >
            {{ contactErrorMessage() }}
          </div>
        }

        @if (successMessage()) {
          <div
            class="mb-2 rounded bg-green-100 p-2 text-center text-sm font-semibold text-green-600"
          >
            {{ successMessage() }}
          </div>
        }

        <div class="flex justify-center pt-2">
          <button
            class="btn-primary min-w-10"
            [disabled]="onboardingForm.invalid || isSubmitting()"
          >
            @if (isSubmitting()) {
              <mat-progress-spinner
                mode="indeterminate"
                color="accent"
                diameter="20"
              ></mat-progress-spinner>
            } @else {
              Send Activation Email
            }
          </button>
        </div>
      </div>
    </form>
  </div>
</section>
